var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderNew2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25980_21424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.89844 1.53906V4.03906",
    stroke: "#0F172A",
    strokeWidth: 1.21651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8984 1.53906V4.03906",
    stroke: "#0F172A",
    strokeWidth: 1.21651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7734 2.78906H4.02344C3.33308 2.78906 2.77344 3.34871 2.77344 4.03906V12.7891C2.77344 13.4794 3.33308 14.0391 4.02344 14.0391H12.7734C13.4638 14.0391 14.0234 13.4794 14.0234 12.7891V4.03906C14.0234 3.34871 13.4638 2.78906 12.7734 2.78906Z",
    stroke: "#0F172A",
    strokeWidth: 1.21651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77344 6.53906H14.0234",
    stroke: "#0F172A",
    strokeWidth: 1.21651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89844 9.03906H5.90473",
    stroke: "#0F172A",
    strokeWidth: 1.21651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39844 9.03906H8.40473",
    stroke: "#0F172A",
    strokeWidth: 1.21651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8984 9.03906H10.9047",
    stroke: "#0F172A",
    strokeWidth: 1.21651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89844 11.5391H5.90473",
    stroke: "#0F172A",
    strokeWidth: 1.21651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39844 11.5391H8.40473",
    stroke: "#0F172A",
    strokeWidth: 1.21651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8984 11.5391H10.9047",
    stroke: "#0F172A",
    strokeWidth: 1.21651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25980_21424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.898438 0.289062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderNew2);
export default __webpack_public_path__ + "static/media/calenderNew2.dc353a2e6e080e6f3b4d64e15c57c98f.svg";
export { ForwardRef as ReactComponent };